import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import Modal from '../../molecules/Modal';
import Paragraph from '../../atoms/Paragraph';
import { useTranslation } from 'react-i18next';
const ImageComparison = styled.div `
    display: grid;
    gap: 30px;
    max-height: 98vh;

    @media only screen and (min-width: 768px) {
        grid-template-columns: 1fr 1fr;
    }
`;
const ImageComparisonItem = styled.div `
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;

    img {
        max-height: 78vh;
        object-position: top center;
        object-fit: contain;
        width: 100%;
    }
`;
const ImageComparisonItemTitle = styled.h3 `
    font-size: 16px;
    margin: 0 0 30px;
`;
const ImageComparisonImage = styled.div `
    background: #e6ebee;
    display: flex;
    flex: 1 1 auto;
    justify-content: center;
    align-items: center;
    padding: 30px;
`;
const CopyrightCheckerImageComparisonModal = ({ open, onClose, originalImage, detectedImage, 'data-testid': testId, }) => {
    const { t } = useTranslation();
    const handleClose = () => {
        onClose();
    };
    const hasParagraph = !!t('copyright_checker.compare_image.paragraph');
    return (_jsx(_Fragment, { children: _jsxs(Modal, { "data-testid": testId, title: t('copyright_checker.compare_image.title'), open: open, onClose: handleClose, maxWidth: '98vw', children: [hasParagraph && (_jsx(Paragraph, { children: t('copyright_checker.compare_image.paragraph') })), _jsxs(ImageComparison, { children: [_jsxs(ImageComparisonItem, { children: [_jsx(ImageComparisonItemTitle, { children: t('copyright_checker.compare_image.original') }), _jsx(ImageComparisonImage, { children: _jsx("a", { target: "_blank", href: originalImage, children: _jsx("img", { src: originalImage, alt: t('copyright_checker.compare_image.original') }) }) })] }), _jsxs(ImageComparisonItem, { children: [_jsx(ImageComparisonItemTitle, { children: t('copyright_checker.compare_image.detection') }), _jsx(ImageComparisonImage, { children: _jsx("a", { target: "_blank", href: detectedImage, children: _jsx("img", { src: detectedImage, alt: t('copyright_checker.compare_image.detection') }) }) })] })] })] }) }));
};
export default CopyrightCheckerImageComparisonModal;
